import { TFunction } from 'react-i18next';
import { PriceType } from 'subdomains/cpo/types/charging-policy';

export function getPriceTypeLabel(
  t: TFunction<'translation', undefined>,
  priceType: PriceType
): string {
  switch (priceType) {
    case 'FLAT':
      return t('tariff.component.priceSelection.flatOption', 'Flat');
    case 'TIME':
      return t('tariff.component.priceSelection.timeOption', 'Time');
    case 'ENERGY':
      return t('tariff.component.priceSelection.energyOption', 'Energy');
    case 'PARKING_TIME':
      return t(
        'tariff.component.priceSelection.parkingTimeOption',
        'Parking Time'
      );
    default:
      return '';
  }
}
